import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FiDownload,
  FiArrowLeft,
  FiExternalLink,
  FiLoader,
} from "react-icons/fi";
import "./Resume.css";

const RESUME_FILE_ID = "1644peLawoe5Doa62xSddknSzwLD5YmvV";
const RESUME_VIEW = `https://drive.google.com/file/d/${RESUME_FILE_ID}/view?usp=sharing`;
const RESUME_PREVIEW = `https://drive.google.com/file/d/${RESUME_FILE_ID}/preview`;
const RESUME_DOWNLOAD = `https://drive.google.com/uc?export=download&id=${RESUME_FILE_ID}`;

function Resume() {
  const [loading, setLoading] = useState(true);

  return (
    <div className="resume-page">
      <div className="resume-page__toolbar">
        <Link to="/" className="resume-page__back">
          <FiArrowLeft /> Back to Portfolio
        </Link>

        <div className="resume-page__actions">
          <a
            href={RESUME_VIEW}
            target="_blank"
            rel="noopener noreferrer"
            className="resume-page__open"
          >
            <FiExternalLink /> Open in Drive
          </a>
          <a href={RESUME_DOWNLOAD} className="resume-page__download">
            <FiDownload /> Download PDF
          </a>
        </div>
      </div>

      <div className="resume-page__viewer">
        {loading && (
          <div className="resume-page__loader">
            <FiLoader className="resume-page__spinner" />
            <p>Loading resume...</p>
          </div>
        )}
        <iframe
          src={RESUME_PREVIEW}
          title="Resume"
          className={`resume-page__iframe ${loading ? "resume-page__iframe--hidden" : ""}`}
          allow="autoplay"
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
}

export default Resume;
